import WorkIcon from '@material-ui/icons/Work';
import EnvironmentCreate from './EnvironmentCreate';
import EnvironmentEdit from './EnvironmentEdit';
import EnvironmentList from './EnvironmentList';
import EnvironmentShow from './EnvironmentShow';

const pages = {
    list: EnvironmentList,
    create: EnvironmentCreate,
    edit: EnvironmentEdit,
    show: EnvironmentShow,
    icon: WorkIcon,
};

export default pages;
